module.exports = __webpack_public_path__ + "imgs/rchamp.24822ee1.webp";